import { useEffect } from 'react';
import { not, propEq } from 'ramda';
import { useChangeLayoutToAuth } from '../context/layout-context';
import { useProcess } from '@fasstech/oip-starter-utils/app';

const AuthLayout = ({ children }) => {
  const { setLayoutToSecured } = useChangeLayoutToAuth();
  const { context } = useProcess();

  useEffect(() => {
    if (not(propEq('viewId', 'LOGIN', context))) {
      setLayoutToSecured();
    }
  }, [context]);

  return (
    <div className={'flex h-screen w-screen'}>
      <div className={'bg-primary flex items-center w-1/3 justify-center'}>
        <img src="/images/logo.svg" style={{ width: '250px' }} />
      </div>
      <div className={'flex items-center w-3/4 bg-gray-50 px-5'}>{children}</div>
    </div>
  );
};

export default AuthLayout;
